module.exports = __webpack_public_path__ + "img/eks.b64e2ae1.png";